import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import Spinner from 'spinner';
import Pagination from 'pagination';
import Box from 'components/box';
import {PageHead} from 'components/header/components';
import {Link} from 'react-router-dom';
import Breadcrumbs from 'components/breadcrumbs';
import {Label, Divider, SearchFail,
  UniversalDateTime, UniversalDateWrapper, UniversalSearchWrapper } from 'components/common';
import {ButtonDefault} from 'components/buttons';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import MailsList from './mails-list';

import {searchMailingAdmin} from 'redux/actions/admin/mailing';

const mapStateToProps = (state) => ({
  mails: state.adminMails.get('mailsList'),
  isFetching: state.adminMails.get('mailsAreLoading')
});

const mapDispatchToProps = (dispatch) => ({
  searchMails: (start_date, end_date, offset) => dispatch(searchMailingAdmin(start_date, end_date, 10, offset))
});

class Mailing extends Component {

  constructor(props) {
    super(props);

    this.state = {
      status: "",
      start_date: moment("01-01-2018", "MM-DD-YYYY"),
      end_date: moment().add(3, 'month')
    }

    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
  }

  onChangeStartDate(date) {
		this.setState({start_date: date})
	}

	onChangeEndDate(date) {
		this.setState({end_date: date})
	}

  componentDidMount() {
		const page = this.props.match.params.page || 1;
		const offset = 10 * (page - 1);
		this.props.searchMails(this.state.start_date, this.state.end_date, offset)
	}
	componentWillReceiveProps(nextProps) {
		if (this.props.match.params.page !== nextProps.match.params.page) {
			const page = nextProps.match.params.page || 1;
			const offset = 10 * (page - 1);
			this.props.searchMails(this.state.start_date, this.state.end_date, offset)
		}
	}

  render() {

    if (this.props.mails === undefined) {
      return <Spinner/>;
    }

    if (this.props.isFetching) {
      return <Spinner />
    }
    return (
      <div>
          <Breadcrumbs>
              <li><Link to="/admin/">Головна</Link></li>
              <li><Link to="/admin/mailing">Розсилки</Link></li>
          </Breadcrumbs>
        <Box>
          <PageHead>
            <h2>Реєстр розсилок</h2>
          </PageHead>
          <span style={{fontWeight: 'bold'}}>Відібрати за терміном виконання</span>
          <Divider/>
          <UniversalSearchWrapper onSubmit={(event) => {
            event.preventDefault();
          this.props.searchMails(this.state.start_date, this.state.end_date)
        }}>
          <UniversalDateWrapper>
            <UniversalDateTime>
              <Label>Початкова дата</Label>
              <DatePicker locale="uk-UA" selected={this.state.start_date} dateFormat="DD-MM-YYYY" onChange={this.onChangeStartDate}/>
            </UniversalDateTime>
            <UniversalDateTime>
              <Label>Кінцева дата</Label>
              <DatePicker locale="uk-UA" selected={this.state.end_date} dateFormat="DD-MM-YYYY" onChange={this.onChangeEndDate}/>
            </UniversalDateTime>
          </UniversalDateWrapper>

            <ButtonDefault type="submit" value="Пошук" />
          </UniversalSearchWrapper>

          <Divider>
            {this.props.mails.get('results').size > 0 ? (
              <MailsList mails={this.props.mails.get('results')} />
            ):(
              <SearchFail>Розсилки відсутні</SearchFail>
            )}
          </Divider>

          <Pagination counts={this.props.mails.get('count')} path={`/admin/mailing/`} matched={this.props.match.params.page} limits={10} />
        </Box>
      </div>
    )
  }
}
Mailing.propTypes = {
  mail: PropTypes.instanceOf(Map),
  onLoad: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(Mailing);



// WEBPACK FOOTER //
// ./src/admin/mailing/index.js